<template>
    <b-container class="mt-5 mb-5">
        <b-card>
            <b-card-body>
                <h4 class="mb-4">Account Settings</h4>

                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <label>First Name <span class="required">*</span></label>
                            <b-form-input v-model="user.first_name"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="7">
                        <b-form-group>
                            <label>Last Name <span class="required">*</span></label>
                            <b-form-input v-model="user.last_name"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <label>E-Mail Address <span class="required">*</span></label>
                            <b-form-input v-model="user.username" type="email"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <label>Password (set to change)</label>
                            <b-form-input v-model="user.password"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>


                <div class="mt-5 mb-5">
                    <b-button variant="success" @click="update()"><i class="fas fa-check-circle mr-3"></i>Save Settings</b-button>
                    <b-button class="ml-3" :to="{name: 'org-dashboard'}">Cancel</b-button>
                </div>
            </b-card-body>
        </b-card>

    </b-container>
</template>

<script>

    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "Edit",
        data: function() {
            return {
                user: {}
            }
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            ...mapActions(['updateUser']),

            update() {
                this.updateUser({id: this.currentUser.id, data: this.user}).then(() => {
                    this.$router.push('/org/dashboard');
                });
            }
        },
        mounted: function() {
            this.user = {
                first_name: this.currentUser.firstName,
                last_name: this.currentUser.lastName,
                username: this.currentUser.username
            }
        }
    }
</script>

<style scoped>

</style>